import { render } from "./GarantepayView.vue?vue&type=template&id=2ac4b366&scoped=true"
import script from "./GarantepayView.vue?vue&type=script&lang=js"
export * from "./GarantepayView.vue?vue&type=script&lang=js"

import "./GarantepayView.vue?vue&type=style&index=0&id=2ac4b366&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac4b366"]])

export default __exports__